import Page from './Page';
import Component from 'vue-class-component';

import template from './MobileOrderApplication.vue.html';
import HeaderComponent from './Header.vue';
import { Order, OrderSerialize } from '../common/merchandise/Order';
@Component({ template, components: { HeaderComponent } })
export default class MobileOrderApplication extends Page {
    showModal: boolean = false;
    seat_name: string = '';

    async created() {
        await this.app.fetchInfo();
        if (!this.app.cart) {
            this.app.setPage('Top');
            return;
        }

        if (!this.app.cart?.orders.length) {
            this.app.setPage('MerchandiseCategories');
            return;
        }

        this.seat_name = this.app.seat_name;
    }

    setSeatName(category: string) {
        if (this.app.last_seat_name.category === category)
            this.seat_name = this.app.last_seat_name.seat_name;
        else this.seat_name = '';
    }

    async confirmPurchase() {
        if (!this.app.cart?.orders.length) return;
        this.setSeatName(this.app.cart.categoryInNeedSeatItem());
        if (this.app.cart.needSeat) {
            this.showModal = true;
            return;
        }
        return this.completeMobileOrder();
    }

    private errorAlert(title: string, orders: OrderSerialize[]) {
        alert(
            [
                this._(title),
                ...orders.map((o) => {
                    const order = new Order(
                        o,
                        this.app.mobile_order_merchandises
                    );
                    return `${this._(order.item.texts.title)} ${
                        order.quantity
                    }${this._(order.item.texts.unit)}`;
                }),
            ].join('\n')
        );
    }

    async completeMobileOrder() {
        if (!this.app.cart) return;
        try {
            const result = await this.app.post('complete-mobile-order', {
                mobile_order_cart: this.app.cart.orders,
                seat_name: this.seat_name,
            });
            if (!result.succeed) {
                console.error(result);
                const message =
                    result.error?.message_code ??
                    (result?.code === 500 ? 'Server Error.' : '');
                throw new Error(message);
            }

            this.app.cart.remove(...(result.ordered ?? []));

            if (result.stock_lack_orders?.length) {
                const orders = result.stock_lack_orders;
                this.errorAlert('imcomplete_order_by_stock_depletion', orders);
                this.app.cart.remove(
                    ...orders.map((o: OrderSerialize) => o.uid)
                );
            }

            if (result.timeout_orders?.length) {
                const orders = result.timeout_orders;
                this.errorAlert('imcomplete_order_by_timeout', orders);
                this.app.cart.remove(
                    ...orders.map((o: OrderSerialize) => o.uid)
                );
            }

            if (result.over_limit_order?.length) {
                const orders = result.over_limit_order;
                this.errorAlert('over_limit_to_order', orders);
            }

            if (result.over_order_count_limit_order?.length) {
                const orders = result.over_order_count_limit_order;
                this.errorAlert('over_order_count_limit_order', orders);
            }

            if (result.overflow_item_variant_order?.length) {
                const orders = result.overflow_item_variant_order;
                this.errorAlert('overflow_item_variant_order', orders);
            }

            if (result.ordered?.length) {
                console.info('ordered', result.ordered);
                this.app.setPage('MobileOrdered');
                alert(this._('complete_order'));
            }
        } catch (err) {
            console.error(err);
            const msg = err instanceof Error ? err.message : String(err);
            alert(this._(msg) || 'Connection Error');
        } finally {
            await this.app.fetchInfo();
        }
        this.$forceUpdate();
    }

    back() {
        this.app.setPage('MerchandiseCategories');
    }

    remove(order: Order) {
        this.app.cart?.remove(order);
        this.$forceUpdate();
    }

    changeQuantity(order: Order, quantity: number) {
        order.quantity = Math.max(1, Math.min(order.stock, quantity));
        this.app.cart?.save(order);
        this.$forceUpdate();
    }
}
